import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { AngularFirestore } from "@angular/fire/compat/firestore";

@Injectable({
  providedIn: "root",
})
export class LoggingService {
  level: LogLevel = LogLevel.All;

  constructor(private firestore: AngularFirestore) {}

  debug(msg: string, rawdata: any, componentName?: string, functionName?: string, ...optionalParams: any[]) {
    this.writeToLog(msg, rawdata, LogLevel.Error, componentName, functionName, optionalParams);
  }

  info(msg: string, rawdata: any, componentName?: string, functionName?: string, ...optionalParams: any[]) {
    this.writeToLog(msg, rawdata, LogLevel.Error, componentName, functionName, optionalParams);
  }

  warn(msg: string, rawdata: any, componentName?: string, functionName?: string, ...optionalParams: any[]) {
    this.writeToLog(msg, rawdata, LogLevel.Error, componentName, functionName, optionalParams);
  }

  error(msg: string, rawdata: any, componentName?: string, functionName?: string, ...optionalParams: any[]) {
    this.writeToLog(msg, rawdata, LogLevel.Error, componentName, functionName, optionalParams);
  }

  fatal(msg: string, rawdata: any, componentName?: string, functionName?: string, ...optionalParams: any[]) {
    this.writeToLog(msg, rawdata, LogLevel.Error, componentName, functionName, optionalParams);
  }

  log(msg: string, rawdata: any, componentName?: string, functionName?: string, ...optionalParams: any[]) {
    this.writeToLog(msg, rawdata, LogLevel.Error, componentName, functionName, optionalParams);
  }

  setlogLevel(level: LogLevel) {
    this.level = level;
  }

  private writeToLog(
    msg: string,
    rawdata: Error,
    level: LogLevel,
    componentName?: string,
    functionName?: string,
    params?: any[]
  ) {
    if (this.shouldLog(level)) {
      let value: Ilogger = {} as Ilogger;
  
      value.LogDate = JSON.stringify(new Date());
      value.LogLevel = LogLevel[level];
      value.Message = msg;
      // if (rawdata) {
      //   value.RawData = rawdata.stack;
      // }
      if (componentName && functionName) {
        value.ComponentName = componentName;
        value.FunctionName = functionName;
      }
      if (params?.length) {
        value.OptionalParams = JSON.stringify(params).toString();
      }
      const valuess = environment.Logging.IsFirebase == true;
      if (valuess) {
        this.LogToFireBase(value);
      }
  
      // Log the value
      console.log(value);
    }
  }

  private shouldLog(level: LogLevel): boolean {
    let ret: boolean = true;
    if (
      (level >= this.level && level !== LogLevel.Off) ||
      this.level === LogLevel.All
    ) {
      ret = true;
    }
    return ret;
  }

  private LogToFireBase(val: Ilogger) {
    this.firestore.collection(" google_apis_call_SA").add({ ...val });
  }

  getAllLogs() {
    return this.firestore.collection(" google_apis_call_SA").snapshotChanges();
  }
}

export interface Ilogger {
  loggerId: string;
  LogDate: string;
  LogLevel: string;
  Message: string;
  OptionalParams: any;
  RawData: any;
  ComponentName:any;
  FunctionName:any;
}

export enum LogLevel {
  All = 0,
  Debug = 1,
  Info = 2,
  Warn = 3,
  Error = 4,
  Fatal = 5,
  Off = 6,
}